import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {QuestionDb} from './questionDbSchema';
import {Question, questionSchema} from './questionSchema';

export function mapQuestionDbToType(db: FirestoreDocSnapshotWithIdAndData<QuestionDb>): Question {
  const data = mapFirestoreDocWithTimestamp(db);
  return questionSchema.parse(data);
}
